export default {
  Form_Common: {
    ZhuShuShi: 'Complaint',
    MaiZhen: 'Pulse',
    SheZhen: 'Tongue',
    BingMing: 'Disease',
    ZhengXing: 'Syndrome',
    ZhiZeZhiFa: 'Treatment',
    YaoPingZhiXingBiaoZhun: 'Drug Enforcement Standard',
    BaoCi: 'Per dose: 1 package',
    KeBao: 'Per package: X grams',
    MiaoShu: 'Describe',
    YinPian_FenLiang: 'Decoction Pieces',
    RiQi: 'Date',
    ZhangHao: 'Account',
    MiMa: 'Password',
    QingShuRu: 'input',
    QingXuanZe: 'select',
    XingMing: 'Name',
    NieCheng: 'Nickname',
    ZhiGong_LeiBie: 'Employee category',
    YiShi: 'Medic',
    ShouQuan_YiShi: 'Authorized medic',
    HuShi: 'Nurse',
    HuShi_Shi: 'Nurse practitioner',
    YaoJiShi: 'Pharmacist',
    QiTa: 'Other',
    ZhengJian_LeiXing: 'ID Type',
    JuMin_ShenFenZheng: 'ID card',
    JuMin_HuKouBu: 'Household register',
    HuZhao: 'Passport',
    JunGuan_Zheng: 'Certificate of officers',
    JiaShi_Zheng: 'Driving licence',
    GangAo_TongXingZheng: 'PRC(HK Card)',
    TaiWan_TongXingZheng: 'PRC(TW Card)',
    ChuSheng_YiXue_ZhengMing: 'Medical certificate of birth',
    ZhengJian_HaoMa: 'ID Number',
    ZhongWen_XingMing: 'Name(Cn)',
    YingWen_XingMing: 'Name(En)',
    DiQu: 'District',
    DiZhi: 'Address',
    XiangXi_DiZhi: 'Detailed',
    ZhaoPian: 'Photo',
    MiaoShu_Text: 'Describe',
    ZhengShu: 'Certificate',
    ZhengShu_BianHao: 'Certificate No',
    YiJianTong_ID: 'eHealth ID',
    ZhengShu_MingCheng: 'Certificate Title',
    FaZheng_ShiJian: 'Issue Date',
    YouXiao_Qi: 'Period of validity',
    FuJian: 'Attachment',
    PaiBan: 'Scheduling',
    Bu_PaiBan: 'Un',
    JueSe_Ming: 'Role Name',
    JueSe_MiaoShu: 'Description',
    QuanXian_FanWei: 'Permission Scope',
    ShuJu_QuanXian: 'Data Permissions',
    Jin_BenRen: 'Self Only',
    YuanGong_SuoZai_ZhenSuo: "Employee's Clinic",
    BuFen_ZhenSuo: 'Some Clinics',
    QuanBu_ZhenSuo: 'All Clinics',
    ShiYong_ZhenSuo: 'Applicable Clinics',
    BingLi_MianShouQuan_ChaKan_TaRen_JiLu:
      'Records entered by others can be viewed without authorization (Medical Records)',
    GuaHao_JinXianShi_BenRen_HaoYuan: 'Only your own appointment slots are shown (Registration)',
    GuaHao_XianShi_QuanBu_HaoYuan: 'All appointment slots are shown (Registration)',
    JinXianShi_BenRen_JingShou_JiLu:
      'Only records handled by yourself are shown (Appointment, Consultation, Billing, Physiotherapy, Dispensing)',
    JinXianShi_QuanBu_JiLu: 'All records are shown (Appointment, Consultation, Billing, Physiotherapy, Dispensing)',
    QuanXuan: 'All',
    ShiFou_PeiSong: 'Delivery or not',
    YouFei: 'Postage',
    Xian_JiuZhen_Hou_FuKuan: 'Visit now, pay later',
    ZhiFu_FangShi: 'Payment method',
    XianShang_ZhiFu: 'Online',
    XianXia_ZhiFu: 'Offline',
    YiBao: 'Medical Insurance',
    Bao: 'Package',
    Ci: 'Time',
    Ke: 'g',
    YaoPin_ZhongLiang: 'Weight',
    WuCha: 'Deviation',
    AnZhao_BiLi_JiSuan: 'Pro rata',
    KaiShi_Zhi: 'Start',
    JieShu_Zhi: 'End',
    ShiFou_YongHu_Quan: 'Subscriber coupon or not',
    ShiFou_GuoQi: 'Expired or not',
    GuoQi_LeiXing: 'Expiration type',
    HuaDong_GuoQi: 'Sliding expiry',
    GuDing_RiQi_GuoQi: 'Fixed date expiry',
    GuoQi_ShiChang: 'Validity duration',
    GouMaiRenYuan_BiaoZhu: '(purchaser)',
    Tian: 'days',
    Yue: 'months',
    Nian: 'years',
    SanTian: '3 days',
    YiZhou: '1 week',
    BanGeYue: 'Half a month',
    YiGeYue: '1 month',
    SanGeYue: '3 months',
    BanNian: 'Half year',
    YiNian: '1 year',
    LiangNian: '2 years',
    SanNian: '3 years',
    WuNian: '5 years',
    ShiFou_ZaiShou: 'On sale or not',
    ShouMai_KaiShi: 'Sale start',
    ShouMai_JieShu: 'Sale end',
    LeiBie: 'Category',
    ZheKou_Quan: 'Discounts',
    ManJian: 'Full minus offer',
    DaiJin_Quan: 'Vouchers',
    YouHuiQuan: 'Coupons category',
    YiLiao_Quan: 'Medical category',
    TaoPiao: 'Ticket category',
    Zi_Medicine: 'Drug',
    Zi_Acupuncture: 'Acup',
    Zi_Img: 'Img',
    Zi_Postage: 'Pot',
    Zi_Fee: 'Fee',
    Zi_Massage: 'Mas',
    Zi_Cupping: 'Cup',
    QiYong: 'Enable',
    TingYong: 'Out of',
    Zhe: '',
    YouHuiQuan_LeiXing: 'Coupon type',
    ShiLi: 'Example',
    ZheKou: 'Discount',
    ShiYong_FanWei: 'Scope of use',
    ChuFang_Dan: 'Prescription',
    ZhenJiu_Dan: 'Acupuncture',
    WenDang_YingXiang_Dan: 'Img',
    LingShou: 'Product',
    OTC: 'OTC',
    KuaiDi_Dan: 'Postage',
    TuiNa_ZhengGu: 'Massage/Boning',
    BaGuan: 'Cupping',
    ShengShi_Qu: 'Address',
    JieShao_TuJing: 'Way',
    PengYou: 'Friend',
    ChuanDan: 'Leaflet',
    BaoZhi_ZaZhi: 'Magazines',
    HuLianWang: 'Internet',
    DianYou: 'Email',
    ChuFang_GongKai: 'Public',
    ShiYong_YiLiao_Quan: 'Medical vouchers',
    YaoPin_JiSuan_GuiGe: 'Drug specification',
    CaoYao: 'Herb',
    NongSuo_Yao: "Nong's",
    YinPian: 'Herbal',
    YaoPin_ZhiXing_BiaoZhun: 'Drug standard',
    DiZhi_XinXi: 'Address',
    ShouHuoRen_XingMing: 'Name',
    ZhiFu_QuDao: 'Payment channel',
    YiLiao_Quan_Item: 'Medical vouchers',
    MeiTuan: 'Meituan',
    ChuZhi_Ka: 'Prepaid Card',
    YaoPin_MingCheng: 'Name',
    YaoPin_BianMa: 'Code',
    PinPai: 'Brand',
    You_Wu_KuCun: 'Inventory',
    You_KuCun: 'On',
    Wu_KuCun: 'Off',
    ShiFou_QiYong: 'Enable',
    ZuiXiao_YuJing_Liang: 'Minimum warning quantity',
    ZuiDa_YuJing_Liang: 'Maximum warning quantity',
    DingDan_BianHao: 'Order No',
    DingDan_ShiJian: 'Order time',
    ZhuangTai: 'Status',
    ZhongDuan: 'Terminal',
    DongZuo: 'Action',
    BeiZhu: 'Remark',
    ShenHe_JieGuo: 'Audit result',
    TongGuo: 'Pass',
    Bu_TongGuo: 'No pass',
    ShenPi_YiJian: 'Approval opinion',
    QianShou_Ren: 'Signer',
    QuanBu_YaoPin: 'All drugs',
    DiaoZheng_ShiJian: 'Check time',
    DianZi_QianMing: 'Signature',
    MingCheng: 'Name',
    YaoWu_JiFei: 'Prescription',
    ZhenJiu_FeiYong: 'Acupuncture',
    LingShou_JiFei: 'Product',
    ChongZhi: 'Top up',
    TaoPiao_JiFei: 'PackageTicket',
    TuiNa_FeiYong: 'Massage',
    BaGuan_FeiYong: 'Cupping',
    ZhongLei: 'Species',
    JiChu: 'Basics',
    ChengBen: 'Cost',
    JiFei: 'Charge',
    TianShu: 'Days',
    ShouJia: 'Price',
    YongLiang: 'Usage',
    TuXiang: 'Picture',
    Zi_Product: 'Prod',
    Zi_Ticket: 'Tick',
    ShouFei_LeiBie: 'Charge category',
    JiFei_ZhongLei: 'Billing',
    JiFei_FangFa: 'Billing method',
    NongSuo_Yao_SheDing: "Nong's setting",
    MoRen: 'Default',
    YinPian_SheDing: 'Herbal setting',
    JiBen_ShouFei: 'Basic',
    MeiTian_ShouFei: 'Days',
    NongSuo_Yao_MeiTian_ShouFei: "Nong's days",
    YinPian_MeiTian_ShouFei: 'Herbal days',
    ShouFei_XiangMu: 'Charge project',
    YuShe_ShouFei: 'Set default',
    YingWen_MingCheng: 'English name',
    NianLing: 'Age',
    ZuBie: 'Group',
    Bu_XianShi: 'Hide',
    ChuFang_NianLing_XianShi: 'Prescription age',
    KaiShi_Zhi_Short: 'Start',
    JieShu_Zhi_Short: 'End',
    Sui: 'Age',
    Ke_BianJi: 'Editable',
    JiBie: 'Level',
    YouHui: 'Level discount',
    QiBu_JinE: 'Starting amount',
    KaPian_MingCheng: 'Name',
    YuYue_RiQi: 'Date',
    JinE: 'Amount',
    HuoDong_MingCheng: 'Name',
    KaiShi_ShiJian: 'Start time',
    JieShu_ShiJian: 'End time',
    ZuMing_Cheng: 'Name',
    XiangQing: 'Detail',
    ChaoShou: 'Over',
    MianShou_XianDing_ChengBen_JinE: 'No limit',
    JiaShou_JinE: 'Additional charge',
    YiShi_LeiXing: 'Physician type',
    ZhuCe_YiShi: 'Registered Doctor',
    BiaoLie_YiShi: 'Listed Doctor',
    ChuZhiKa_ChongZhi: 'Top up',
    KeHu_JieShou_TuiGuang: 'Accepts promotion',
    DuiZhang_ShiJian: 'Time',
    DingDan_Shu: 'Quantity',
    ShangPin_ZhuangTai: 'Product status',
    ShangPin_MingCheng: 'Product name',
    QiTa_LianXi_FangShi: 'Other contact',
    An_Ri: 'Day',
    An_Yue: 'Month',
    DingDan_LaiYuan: 'Source',
    ShouKuan: 'Received',
    TuiKuan: 'Refund',
    Wei_ZhiFu: 'PendingPayment',
    Dai_TiHuo: 'PickUp',
    Yi_WanCheng: 'Completed',
    TuiDan: 'Refunded',
    ZuoFei: 'Abandoned',
    YiShi_XingMing: 'Staff name',
    ShiFou_PaiBan: 'Scheduling',
    YaoPin_DaBao: 'Split method',
    An_XiaoLv: 'Efficiency',
    An_JingDu: 'Precision',
    XiangMu_JiaGe: 'Price',
    XiangMu_MiaoShu: 'Describe',
    XiangMu_ShiJian: 'Time',
    GuanLian_XiangMu: 'Project',
    TaoPiao_MingCheng: 'Name',
    ShiFou_GuoQi_Short: 'Expired',
    GuoQi: 'Expired',
    Wei_GuoQi: 'Not Expired',
    PaiXu_XuHao: 'Sort',
    ZhenZheng_Xu_Shu_Ru_ZiLiao: 'Required',
    SuoYou_LanWei: 'All',
    DanWei: 'Unit',
    ShuRu_DanWei: 'InputUnit',
    ChuFang_DanWei: 'Use Unit',
    YaoPin_PaiXu: 'Sort',
    ShuRu: 'Input',
    DaYin_LeiXing: 'Type',
    Mei_Jie_ShiJian: 'Duration per shift',
    ShengCheng_HaoYuan_TianShu: 'Source days',
    GuiZe_MingCheng: 'Rule Name',
    YouXiao_RiQi: 'Valid Date',
    QuanBu: 'All',
    YingYe_ShiJian: 'Opening hours',
    XingQi: 'Custom Week',
    HaoYuan: 'Custom Source',
    PaiBan_Rules: 'Scheduling',
    ShuoMing: 'Notes',
    ShuoMing_En: 'Notes(En)',
    BingRen_XingMing: 'Patient Name',
    Ming_En: 'First Name',
    Xing_En: 'Last Name',
    ZhenSuo_ZhuanTai: 'Clinic Status',
    ZhenSuo_BianMa: 'Clinic Code',
    ZhenSuo: 'Clinic',
    KaiMen_ShiJian: 'Opening',
    GuanMen_ShiJian: 'Closing',
    ZhenSuo_MinCheng: 'Name',
    YingWen_MinCheng: 'English',
    YingWen_DiZhi: 'English Address',
    JingWeiDu: 'Longitude and Latitude',
    ZhenSuo_Logo: 'Clinic Logo',
    ZhenSuo_ZhaoPian: 'Photos',
    YouWu_Biaozhun: 'Availability',
    YaoPin_YingWen_MingCheng: 'English Name',
    ShiFou_FuFangYao: 'Is Combo',
    PinYin_ShouZiMu: 'Pinyin Initial',
    GongNeng: 'Dict Func',
    GuiGe_YingWen: 'English',
    ChengFen_JiSuanLiang: 'Assay Qty',
    ZhuCe_BianMa: 'Regcode',
    RuKu_DanWei: 'Unit',
    RuKu_DanWeiLiang: 'Unit Qty',
    AnQuanLiang: 'Safety',
    MoRen_DanJia: 'Unit Price',
    MoRen_ChengBenjia: 'Cost Price',
    JiWangShi: 'Medical History',
    ZiDian_LeiXing: 'Dict Type',
    YingWen_Ming: 'First Name',
    YingWen_Xing: 'Last Name',
    BuXian: 'No limit',
    HaoYuan_Shu: 'Number',
    ShiDuan: 'Time',
    DangQian: 'Current',
    QueRen_MiMa: 'Confirm',
    Xin_MiMa: 'New Password',
    QueRen_Xin_MiMa: 'Confirm New',
    Yuan_MiMa: 'Current Password',
    Xin_ZhangHao: 'New Account',
    Xin_NieCheng: 'New Nickname',
    YingYe_DiDian: 'Location',
    PanDian_ShiJian: 'Stocktaking Time',
    TiaoZheng_ShiJian: 'Adjustment Time',
    TiaoZheng_YuanYin: 'Adjustment Reason',
    MingGui_FuJia: 'Surcharge',
    FuJia_LeiXing: 'Type',
    An_ZhongLiang: 'Weight',
    An_TianShu: 'Flavor',
    Mian_FuJiaFei_EDu: 'Free Surcharge',
    MingGui_YaoCai: 'Precious Overcharge',
    ZhiFu: 'Pay',
    ZhiKu: 'TermBank',
    ZhengZhuang: 'Symptom',
    BiaoJi: 'Emarks',
    ZuoYon: 'Effect',
    ZhongZheng: 'Severe',
    ShangPin_GuiGe_MingCheng: 'Product Sku Name',
    XiaoShou_DanWei: 'Sales Unit',
    XiaoShou_RenYuan: 'Sales Staff',
    KunBan_YouHui: 'Bundle',
    DanPin_YouHui: 'Individual',
    ChengPinYao: 'Finished',
    YuYue: 'Appointment',
    Yi_TuiKuan: 'Refunded',
    BuFen_ZhiFu: 'Partial payment',
    KuCun_GaoJing: 'Low Stock',
    LiLiao_YiShi: 'Physician',
    JinJi_LeiXing: 'Taboo Type',
    JinJi_MoBan: 'Taboo',
    BieMing: 'Alias',
    ZuZhi: 'Org',
    ZuZhi_BianMa: 'Org Code',
    ZuZhi_MinCheng: 'Org Name',
    MiYao: 'Key',
    MiYao_MinCheng: 'Key Name',
    YuMing: 'Domain',
    ChengYuan_ShangXian: 'Member Limit',
    JinZhi_XinZeng: 'Prohibit New',
    BianDong_LaiYuan: 'Source',
    BianDong_ShiJian: 'Change time',
    JianChaDan_DaLeiXing: 'Check Type',
    ZhiBiao_BianMa: 'Code',
    ZhiBiao_MingCheng: 'Indicator Name',
    YingWen_SuoXie: 'Abbr.',
    CanKao_FanWei: 'Ref.Range',
    CanKao_FanWei_XiaXian: 'Ref. Lower',
    CanKao_FanWei_ShangXian: 'Ref. Upper',
    LinChuang_ShuoMing: 'Clinical Note',
    XinZeng_JinJi_MoBan: 'Add Taboo',
    XiuGai_JinJi_MoBan: 'Edit Taboo',
    Zhu_HuanZhe: 'Primary Patient',
    Dai_HeBing_HuanZhe: 'Patients to Merge',
    KuaiJie_TuiJian: 'Quick Filter:',
  },
}
